import React, { Component } from "react";
import {
  buildTableConfigPartHarian,
  mapLaporanPartHarianByMekanik,
  mapToSimpleNestedTable,
  monthOptions,
  yearOptions,
} from "../config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleNestedTable from "../../../../../../modules/SimpleNestedTable";
import moment from "moment";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import * as R from "ramda";
import { mapToObjectDDL } from "../../../../../common/mapper";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { buildExcelRequestBodyPartByMekanik } from "../configExcel";
import { saveAs } from "file-saver";
class LaporanPartHarianByMekanik extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable: [],
      mechanicNameOptions: [],
      rawData: null
    };
  }

  componentDidMount() {
    let currentDate = new Date();
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
    }));
    this.fetchDataMechanic();
  }

  componentDidUpdate(prevProps) {
    const prevCabang = prevProps.search?.selectedCabang;
    const currentCabang = this.props.search?.selectedCabang;

    if (prevCabang !== currentCabang && currentCabang) {
      this.fetchDataMechanic();
    }
  }

  fetchDataMechanic = async () => {
    const selectedCabang = this.props.search?.selectedCabang;
    if (!selectedCabang) return;

    const kodeCabang = [selectedCabang];

    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")
        .getMechanicForDropDownListDashboard,
      menuName: "Dashboard Level Mekanik & SA - Laporan Harian Part By Mekanik",
      args: kodeCabang,
    });
    this.props.triggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        mechanicNameOptions: res.data.data.map((item) =>
          mapToObjectDDL(item.mechanicName, item.idEmployee),
        ),
      });
    }
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanHarianPartByMekanik,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Mekanik & SA - Laporan Part Harian By Mekanik",
        args: {
          listCabang: [this.props.search.selectedCabang],
          year: this.state.year.value,
          month: this.state.month.value,
          employeeId: this.state.mekanik ? this.state.mekanik.value : null,
        },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        const { data, config } = mapToSimpleNestedTable({
          apiData: res.data.data,
          month: this.state.month.value,
          year: this.state.year.value,
        });

        this.setState({
          dataTable: data,
          tableConfig: config,
          rawData: res.data.data
        });
      }

      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.error("Error Fetching", error);
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    this.props.triggerLoading();
    const { month, year, rawData, mekanik } = this.state;

    const reqBody = buildExcelRequestBodyPartByMekanik({
      month,
      year: year.value,
      rawData,
      mekanik 
    });

    try {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
        menuName: "Dashboard Level Mekanik dan SA - Laporan Part Harian By Mekanik",
        setError: this.props.setError,
        args: reqBody,
      });

      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `${reqBody.filename}.xlsx`);
      }
    } catch (error) {
      console.error("Error saat generate Excel:", error);
    }

    this.props.triggerLoading();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />

          <SimpleDDL
            id="select_options_mekanik"
            box="search"
            name="mekanik"
            containerclassname="width width-250px"
            placeholder="Nama Mekanik"
            menuPosition="fixed"
            options={this.state.mechanicNameOptions}
            value={this.state.mekanik}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleNestedTable
          data={this.state.dataTable}
          config={this.state.tableConfig}
        />

        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </>
    );
  }
}

export default LaporanPartHarianByMekanik;
